import PageTitle from "@/components/PageTitle";
import DashLayout from "@/layouts/DashLayout";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import Spinner from "@/components/Spinner";
import { useAppSelector } from "@/redux/features/hooks";
import { Roles } from "@/redux/services/user/user.type";
import StaffActivityList from "@/components/pos/activity/StaffActivityList";

function ActivityLogsPage() {
  const currentRestaurant = useAppSelector(
    (state) => state.user.currentRestaurant
  );

  return (
    <DashLayout>
      <RoleProtectedPage allowedRoles={[Roles.manager, Roles.owner]}>
        <div className="space-y-6">
          <PageTitle title="Journal d'activité" description="Journal des actions du personnel" />
          {currentRestaurant ? (
            <StaffActivityList restaurantId={currentRestaurant.id} />
          ) : (
            <div className="flex items-center justify-center py-12">
              <Spinner />
            </div>
          )}
        </div>
      </RoleProtectedPage>
    </DashLayout>
  );
}

export default ActivityLogsPage;
